import React from 'react';
import { BarLoader } from 'react-spinners';
import './LoadingSpinner.css';

function LoadingSpinner() {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <BarLoader
                    color="#ffffff"
                    height={4}
                    width={150}
                    speedMultiplier={1}
                />
                <p className="loading-text">데이터를 불러오는 중...</p>
            </div>
        </div>
    );
}

export default LoadingSpinner;
